module.exports = __webpack_public_path__ + "img/85dd604.png";